import * as React from 'react';
import {Component} from "react";
// @ts-ignore
import "./gender_restrictions.css";
import {TFunction} from "i18next";

const ALL_GENDERS = ['woman', 'man', 'other', 'not_answered'];

interface IGenderRestrictionsProps {
    genders: string[],
    translation: TFunction
    extraInfoMessage: string
    forPassModal: boolean
}

interface IGenderRestrictionsState {
    showInclusivityButton: boolean,
    showInclusivityPopover: boolean
}

class GenderRestrictions extends Component<IGenderRestrictionsProps, IGenderRestrictionsState> {
    private readonly buttonRef: React.RefObject<HTMLAnchorElement>;
    private readonly popoverRef: React.RefObject<HTMLSpanElement>;

    constructor(props: IGenderRestrictionsProps) {
        super(props);
        this.state = {
            showInclusivityButton: false,
            showInclusivityPopover: false
        }

        this.buttonRef = React.createRef();
        this.popoverRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);

        if (this.isAllGenders()) {
            return;
        }

        const hasMenOrWomenGenders = this.props.genders.find((gender) => {
            return gender === 'woman' || gender === 'man'
        }) !== undefined;
        const hasInclusiveGenders = this.props.genders.find((gender) => {
            return gender === 'other' || gender === 'not_answered'
        }) !== undefined;

        if (hasMenOrWomenGenders && hasInclusiveGenders) {
            this.setState({
                showInclusivityButton: true
            })
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    isAllGenders(): boolean {
        const {genders} = this.props;

        if (genders.length === 0 ) {
            return true;
        }

        if (genders.length !== ALL_GENDERS.length) {
            return false;
        }

        return genders.sort().every((value, index) => value === ALL_GENDERS.sort()[index]);
    }

    getGendersRestrictionText = (): string => {
        const {genders, translation} = this.props;

        let gendersText = translation('genderRestrictions.for');

        if (this.isAllGenders()) {
            return gendersText + translation('genderRestrictions.all');
        }

        let filteredGenders = genders.filter((gender) => gender === 'woman' || gender === 'man');

        if (filteredGenders.length === 0) {
            gendersText += translation("genderRestrictions." + genders[0]);
            gendersText += genders[1] ? translation('genderRestrictions.and') + translation("genderRestrictions." +genders[1]) : "";
        }

        if (filteredGenders.length === 1) {
            return gendersText + translation('genderRestrictions.' + genders[0]);
        }

        for (let [key, gender] of Object.entries(filteredGenders)) {
            gendersText += translation('genderRestrictions.' + gender);

            if (Number(key) === filteredGenders.length - 2) {
                gendersText += translation('genderRestrictions.and');
            }
        }

        return gendersText;
    };

    toggleInclusivityPopover = (e:any) => {
        e.stopPropagation()

        this.setState({
            showInclusivityPopover: !this.state.showInclusivityPopover
        })
    }

    handleClickOutside = (event: MouseEvent) => {
        if (this.popoverRef.current && !this.popoverRef.current.contains(event.target as Node) &&
            this.buttonRef.current && !this.buttonRef.current.contains(event.target as Node)) {
            if (this.state.showInclusivityPopover) {
                this.setState({showInclusivityPopover: false});
            }
        }
    };

    getInclusivityText = () => {
        const {translation} = this.props;

        const containsOther = this.props.genders.find((gender) => gender === 'other') !== undefined;
        const containsNoAnswer = this.props.genders.find((gender) => gender === 'not_answered') !== undefined;

        let text = translation('genderRestrictions.inclusiveText');

        if (containsOther && containsNoAnswer) {
            return text + translation('genderRestrictions.inclusivityBirthSexText')
                + translation('genderRestrictions.and')
                + translation('genderRestrictions.inclusivityNoGenderText');
        }

        if (containsOther) {
            return text + translation('genderRestrictions.inclusivityBirthSexText');
        }

        if (containsNoAnswer) {
            return text + translation('genderRestrictions.inclusivityNoGenderText');
        }

        return "";
     }

    render() {
        const {extraInfoMessage, genders} = this.props;
        const {showInclusivityButton, showInclusivityPopover} = this.state;

        return (
            !genders
                ? <p></p>
                : <span className={'gender-restrictions'} onClick={showInclusivityButton ? this.toggleInclusivityPopover : () => null}>
                    {
                        this.getGendersRestrictionText()
                    }
                    {
                        extraInfoMessage
                    }
                    {
                        showInclusivityButton &&
                        <a className={"gender-restrictions--inclusivity-button"} ref={this.buttonRef} onClick={this.toggleInclusivityPopover}> * </a>
                    }
                    {
                        showInclusivityPopover &&
                        <span ref={this.popoverRef} onClick={this.toggleInclusivityPopover}
                              className={"gender-restrictions--tooltip-text" + (this.props.forPassModal ? " for-pass-modal" : "")}>{this.getInclusivityText()}</span>
                    }
                </span>
        );
    }
}

export default GenderRestrictions;
